import { styled } from "styled-components";

export const StandardOptionsContainer = styled.div`
  display: flex;
  justify-content: stretch;
  gap: 12px;
`;
